import styled from 'styled-components';

export const SPANM = styled.span`
  font-weight: 500;
`;
